import { render, staticRenderFns } from "./Slider.component.vue?vue&type=template&id=9c5d41ee&scoped=true"
import script from "./Slider.component.vue?vue&type=script&lang=js"
export * from "./Slider.component.vue?vue&type=script&lang=js"
import style0 from "./Slider.component.vue?vue&type=style&index=0&id=9c5d41ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5d41ee",
  null
  
)

export default component.exports